<template>
  <v-footer app padless color="transparent" class="citation-banner">
    <v-col class="text-center py-1 px-4" cols="12">
      <span class="citation-text">
        CUPP is free and open to all — no login required. Questions:
        <a href="mailto:cupp@bio.dtu.dk">cupp@bio.dtu.dk</a>. &nbsp;·&nbsp; When
        using CUPP, please cite:
        <a href="https://doi.org/10.1093/nar/gkad385">NAR 2023</a> ·
        <a href="https://doi.org/10.1093/nar/gkaa375">NAR 2020</a> ·
        <a href="https://doi.org/10.1186/s13068-019-1436-5"
          >Biotechnol. Biofuels 2019</a
        >
      </span>
    </v-col>
  </v-footer>
</template>

<script>
export default {
  name: "CitationFooter",
};
</script>

<style scoped>
.citation-banner {
  /* Frozen at the viewport bottom (v-footer app), thin + translucent so it is
     always visible without scrolling, similar to the iTOL footer. */
  background-color: rgba(245, 245, 245, 0.85) !important;
  backdrop-filter: blur(3px);
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  min-height: 0;
}
.citation-text {
  font-size: 11px;
  line-height: 1.2;
  color: rgba(0, 0, 0, 0.6);
}
.citation-banner a {
  text-decoration: none;
}
.citation-banner a:hover {
  text-decoration: underline;
}
</style>
